import { render, staticRenderFns } from "./EntriesList.vue?vue&type=template&id=bc0be656&scoped=true"
import script from "./EntriesList.vue?vue&type=script&lang=js"
export * from "./EntriesList.vue?vue&type=script&lang=js"
import style0 from "./EntriesList.vue?vue&type=style&index=0&id=bc0be656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0be656",
  null
  
)

export default component.exports